import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Constants } from "../../../constants";
import { environment } from "../../../environments/environment";

@Injectable()
export default class CacheBustInterceptorService implements HttpInterceptor {
    // Cache busting for html pages based on global version letiable
    // left as 'any' because interceptors are meant to be generic
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.indexOf(".html") > -1 && req.url.indexOf("uib/template") === -1) {
            // Clone the request so we can modify the read-only fields and return our own values
            const authReq = req.clone({
                url:
                    req.url +
                    (req.url.indexOf("?") > -1 ? "&v=" + environment.appVersion : "?v=" + environment.appVersion),
            });

            // send cloned request with header to the next handler.
            return next.handle(authReq);
        }

        return next.handle(req);
    }
}
